import { render, staticRenderFns } from "./EventForm4Component.vue?vue&type=template&id=a5033c2a&"
import script from "./EventForm4Component.vue?vue&type=script&lang=js&"
export * from "./EventForm4Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports